"use strict";

var _slicedToArray = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var create = require("@waves/parse-json-bignumber/dist/parse-json-bignumber");

var _create = create(),
    parse = _create.parse,
    stringify = _create.stringify;

var schemas_1 = require("./schemas");

var serializePrimitives_1 = require("./serializePrimitives");

var index_1 = require("./index");

function resolvePath(path, obj) {
  if (path.length === 0) return obj;
  if (typeof obj !== 'object') return undefined;
  return resolvePath(path.slice(1), obj[path[0]]);
}

var isLongProp = function isLongProp(fullPath, fullSchema, targetObject) {
  function go(path, schema) {
    if (schema == null) return false;
    if (path.length === 0 && (schema.type === 'primitive' || schema.type === undefined)) return schema.toBytes === serializePrimitives_1.LONG;

    if (schema.type === 'object') {
      var field = schema.schema.find(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            _ = _ref2[1];

        return name === path[0];
      });
      return go(path.slice(1), field && field[1]);
    }

    if (schema.type === 'array') {
      return go(path.slice(1), schema.items);
    }

    if (schema.type === 'dataTxField') {
      if (path[0] !== 'value') return false;
      var dataObj = resolvePath(fullPath.slice(0, fullPath.length - 1), targetObject);
      var dataSchema = schema.items.get(dataObj.type);
      return go(path.slice(1), dataSchema);
    }

    if (schema.type === 'anyOf') {
      // Find object and get it's schema
      var obj = resolvePath(fullPath.slice(0, fullPath.length - 1), targetObject);
      var objType = obj[schema.discriminatorField];
      var objSchema = schema.itemByKey(objType);
      if (!objSchema) return false; // If valueField exists in schema we also check if value and not type field is currently processed. E.g:
      // {type: 'integer', value: 1000}

      if (schema.valueField != null && fullPath[fullPath.length - 1] === schema.valueField) {
        return go(path.slice(1), objSchema.schema);
      } //  Otherwise whole object is used as value. E.g.: {type:14, sender: 'example', amount: 1000}
      else {
          return go(path, objSchema.schema);
        }
    }

    return false;
  }

  return go(fullPath, fullSchema);
};
/**
 * Converts object to JSON string using binary schema. For every string found, it checks if given string is LONG property.
 * If true - function writes this string as number
 * @param obj
 * @param schema
 */


function stringifyWithSchema(obj, schema) {
  var path = [];
  var stack = [];

  function stringifyValue(value) {
    if (typeof value === 'string') {
      // ///TODO: DIRTY HACK
      // if (value === 'integer'
      //   && path[0] === 'call'
      //   && path[1] === 'args'
      //   && path[3] === 'type'
      // ) { return `"${value}"` }
      if (isLongProp(path, schema, obj)) {
        return value;
      }
    }

    if (typeof value === 'boolean' || value instanceof Boolean || value === null || typeof value === 'number' || value instanceof Number || typeof value === 'string' || value instanceof String || value instanceof Date) {
      return JSON.stringify(value);
    }

    if (Array.isArray(value)) {
      return stringifyArray(value);
    }

    if (value && typeof value === 'object') {
      return stringifyObject(value);
    }

    return undefined;
  }

  function stringifyArray(array) {
    var str = '[';
    var stackIndex = stack.length;
    stack[stackIndex] = array;

    for (var i = 0; i < array.length; i++) {
      var key = i + '';
      var item = array[i];

      if (typeof item !== 'undefined' && typeof item !== 'function') {
        path[stackIndex] = key;
        str += stringifyValue(item);
      } else {
        str += 'null';
      }

      if (i < array.length - 1) {
        str += ',';
      }
    }

    stack.length = stackIndex;
    path.length = stackIndex;
    str += ']';
    return str;
  }

  function stringifyObject(object) {
    var first = true;
    var str = '{';
    var stackIndex = stack.length;
    stack[stackIndex] = object;

    for (var key in object) {
      if (object.hasOwnProperty(key)) {
        var value = object[key];

        if (includeProperty(value)) {
          if (first) {
            first = false;
          } else {
            str += ',';
          }

          str += '"' + key + '":';
          path[stackIndex] = key;
          str += stringifyValue(value);
        }
      }
    }

    stack.length = stackIndex;
    path.length = stackIndex;
    str += '}';
    return str;
  }

  function includeProperty(value) {
    return typeof value !== 'undefined' && typeof value !== 'function';
  }

  return stringifyValue(obj) || '';
}

exports.stringifyWithSchema = stringifyWithSchema;
/**
 * Safe parse json string to TX. Converts unsafe numbers to strings. Converts all LONG fields with converter if provided
 * @param str
 * @param toLongConverter
 */

function parseTx(str, toLongConverter) {
  var tx = parse(str);
  return toLongConverter ? index_1.convertTxLongFields(tx, toLongConverter) : tx;
}

exports.parseTx = parseTx;
/**
 * Converts transaction to JSON string.
 * If transaction contains custom LONG instances and this instances doesn't have toString method, you can provide converter as second param
 * @param tx
 * @param fromLongConverter
 */

function stringifyTx(tx, fromLongConverter) {
  var type = tx.type,
      version = tx.version;
  var schema = schemas_1.getTransactionSchema(type, version);
  var txWithStrings = index_1.convertLongFields(tx, schema, undefined, fromLongConverter);
  return stringifyWithSchema(txWithStrings, schema);
}

exports.stringifyTx = stringifyTx;
/**
 * Safe parse json string to order. Converts unsafe numbers to strings. Converts all LONG fields with converter if provided
 * @param str
 * @param toLongConverter
 */

function parseOrder(str, toLongConverter) {
  var ord = parse(str);
  var schema = ord.version === 2 ? schemas_1.orderSchemaV2 : schemas_1.orderSchemaV1;
  return toLongConverter ? index_1.convertLongFields(ord, schema, toLongConverter) : ord;
}

exports.parseOrder = parseOrder;
/**
 * Converts order to JSON string
 * If order contains custom LONG instances and this instances doesn't have toString method, you can provide converter as second param
 * @param ord
 * @param fromLongConverter
 */

function stringifyOrder(ord, fromLongConverter) {
  var schema = ord.version === 2 ? schemas_1.orderSchemaV2 : schemas_1.orderSchemaV1;
  var ordWithStrings = index_1.convertLongFields(ord, schema, undefined, fromLongConverter);
  return stringifyWithSchema(ordWithStrings, schema);
}

exports.stringifyOrder = stringifyOrder;